import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const TableDataContext = createContext();

export const TableDataProvider = ({ data, ...props }) => {
  return <TableDataContext.Provider value={{ data }} {...props} />;
};

TableDataProvider.propTypes = {
  data: PropTypes.array,
};

TableDataProvider.defaultProps = {
  data: [],
};

export const useTableData = () => {
  const context = useContext(TableDataContext);

  if (context === undefined) {
    throw new Error('useTableData must be used within a TableDataProvider');
  }

  return context;
};
